import { EffUsernameGenerationOptions } from "../types";

/** The default options for EFF long word generation. */
export const DefaultEffUsernameOptions: EffUsernameGenerationOptions = Object.freeze({
  wordCapitalize: false,
  wordIncludeNumber: false,
  website: null,
});
